import http from "../app/httpService";

const apiEndpoint = process.env.REACT_APP_MARKET_DATA_API + "BcObpsRegistry/";

export async function getIssuances() {
  const { data: issuances } = await http.get(apiEndpoint + "issuances");
  return issuances;
}

export async function getHoldings() {
  const { data: holdings } = await http.get(apiEndpoint + "holdings");
  return holdings;
}

export async function getRetirements() {
  const { data: retirements } = await http.get(apiEndpoint + "retirements");
  return retirements;
}
